module.exports = __webpack_public_path__ + "static/index/img/baikal-302.9a48cf50.jpg";